// useUpdateOrderStatusMutation.js
import { useMutation, useQueryClient } from "react-query";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";
import { deleteRepairService } from "api/repair-orders";

const useDeleteService = () => {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation(deleteRepairService, {
    onMutate: async ({ repairOrderId, serviceId }) => {
      // Cancel any outgoing refetches
      await queryClient.cancelQueries({
        queryKey: ["repairOrder", repairOrderId],
      });

      //cancel any mutations

      // Snapshot the previous data
      const previousOrder = queryClient.getQueryData([
        "repairOrder",
        repairOrderId,
      ]);

      if (!previousOrder) {
        console.error("No previous order found");
        console.log("repairOrderId", repairOrderId);
        return;
      }

      //Remove the service from the services array
      queryClient.setQueryData(["repairOrder", repairOrderId], (old) => ({
        ...old,
        updatedAt: dayjs().toISOString(),
        services: old.services.filter((service) => service.id !== serviceId),
      }));

      // Return context with the previous order for rollback
      return { previousOrder };
    },
    onError: (error, variables, context) => {
      if (context?.previousOrder) {
        queryClient.setQueryData(
          ["repairOrder", variables.repairOrderId],
          context.previousOrder
        );
      }
      console.log(error.response);
      console.error(error?.response?.data?.message || "Error deleting service");
      enqueueSnackbar("Failed to delete service", { variant: "error" });
    },
    onSuccess: (data, variables) => {
      enqueueSnackbar("Service delete successfully", { variant: "success" });
    },
    // onSettled: (data, error, variables) => {
    //   queryClient.invalidateQueries(["repairOrder", variables.repairOrderId]);
    // },
  });
};

export default useDeleteService;
